<template>
    <div class="flex items-start gap-[10px]" :class="is_agent ? 'flex-row-reverse' : ''">
        <ContactNameIcon badgeClass="name_icon_b" nameLetter="HC" :isTab="true" :isFull="false" />
        <div class="max-w-[70%]">
            <div
                class="p-6 flex flex-col gap-4 items-start bg-gray-100"
                :class="{
                    '!bg-[#A9E5FF] flex-row-reverse rounded-l-xl rounded-br-2xl': is_agent,
                    'bg-gray-100 rounded-r-xl rounded-bl-2xl': !is_agent,
                    '!p-3': size === 'sm',
                }"
            >
                <slot name="chat_top" />
                <slot name="message">
                    <div
                        v-if="message.contentType === 'text' || message.contentType === 'bot'"
                        class="offer-box-footer break-all whitespace-pre-line"
                        :class="{
                            'text-sm': size === 'sm',
                        }"
                    >
                        {{
                            Array.isArray(message?.content) && message?.content.length === 0
                                ? message?.botLinkedData?.currentBot
                                    ? JSON.parse(message?.botLinkedData?.currentBot)?.name + " was triggred"
                                    : message.content
                                : message.content
                        }}
                    </div>
                    <div
                            v-else-if="message.contentType === 'image'"
                            class="max-w-[278px] rounded-xl !rounded-tl-none"
                            >
                            <div
                                :class="
                                    message.content.length > 1
                                        ? 'grid grid-cols-2 gap-1'
                                        : ''
                                "
                            >
                                <div
                                    v-for="(image, index) in message.content.slice(
                                        0,
                                        4
                                    )"
                                    :key="index"
                                    class="relative rounded-none [&:nth-child(even)]:rounded-tr-xl [&:nth-child(4)]:rounded-br-xl [&:nth-child(4)]:!rounded-tr-none [&:nth-child(odd)]:rounded-tl-xl [&:nth-child(3)]:!rounded-bl-xl [&:nth-child(3)]:!rounded-tl-none"
                                    :class="
                                        message.content.length === 2
                                            ? '[&:nth-child(1)]:!rounded-bl-xl [&:nth-child(2)]:!rounded-br-xl'
                                            : ''
                                    "
                                >
                                    <template v-if="message.content.length > 1">
                                        <img
                                            :key="index"
                                            class="bg-gray-100 text-sm h-24 w-auto rounded-[inherit]"
                                            :src="image"
                                        />
                                        <div
                                            v-if="
                                                index === 3 &&
                                                message.content.length > 3
                                            "
                                            class="absolute backdrop-blur-[4px] w-full h-full top-0 rounded-none bg-black bg-opacity-60 rounded-br-xl flex items-center justify-center text-[34px] font-normal text-white"
                                        >
                                            +4
                                        </div>
                                    </template>
                                    <img
                                        v-else
                                        :key="index"
                                        class="bg-gray-100 rounded-xl rounded-tl-none text-sm mb-2 h-40 w-auto"
                                        :src="image"
                                    />
                                </div>
                            </div>
                        </div>
                </slot>
            </div>
            <div v-if="message_time || is_read" class="box-time">
                <p class="text-gray-500 text-xs font-normal mt-[10px]">
                    <span v-if="message_time">
                        {{ formatTime(message_time) }}
                    </span>
                    <fa v-if="is_read && is_agent" class="ml-[2px]" color="#00B0FC" :icon="['fal', 'check-double']"></fa>
                </p>
            </div>
        </div>
    </div>
</template>

<script setup>
import ContactNameIcon from "@/components/contacts/ContactNameIcon.vue";

const props = defineProps({
    message: {
        type: String,
        default: "",
    },
    message_time: {
        type: String,
        default: "",
    },
    is_read: {
        type: Number,
        default: 0,
    },
    is_agent: {
        type: Boolean,
        default: false,
    },
    size: {
        type: String,
        default: "lg",
        validator: (value) => ["sm", "md", "lg"].includes(value),
    },
});

const formatTime = (timestamp) => {
    try {
        if (!timestamp) return;
        const date = new Date(timestamp);
        return date.toISOString().slice(11, 16);
    } catch (e) {
        return "00:00";
    }
};
</script>

<style></style>
